import {Component, inject, Input, ChangeDetectionStrategy} from '@angular/core';
import {IconComponent} from "../icon/icon.component";
import {AsyncPipe} from "@angular/common";
import {MobileService} from "../../services/mobile.service";

@Component({
    selector: 'app-button',
    imports: [
    IconComponent,
    AsyncPipe
],
    templateUrl: './button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './button.component.scss'
})
export class ButtonComponent {
  readonly mobileService: MobileService = inject(MobileService);

  @Input() block: boolean = false;
  @Input() icon: string = '';
  @Input() disabled: boolean = false;
  @Input() type: 'primary' | 'outline' | 'icon-only' = 'primary';
  @Input() actionType: 'edit' | 'delete' | 'info' = 'info';
  @Input() link: string = '';
  @Input() ariaLabel: string = '';
  @Input() iconType: 'solid' | 'regular' | 'light' | 'duotone' | 'brands' = 'regular';
  /** @deprecated: place your content in the component content instead */
  @Input() text: string = '';
  @Input() animate: boolean = false;
  protected readonly window: Window & typeof globalThis = window;

  protected openLink(): void {
    if (this.disabled || !this.link) {
      return;
    }

    window.open(this.link);
  }
}
